import { type } from "os";
import React, { FunctionComponent, useEffect, useState } from "react";
import { Button } from "../Button";
import IconButton from "../iconButton/IconButton";
import "./Modal.css";
import { useErrorHandlingStore } from "../../../hooks/useErrorHandling";

export type SetHandler = () => void; 

export type ModalProps = {
    children: any,
    title?: string | JSX.Element,
    wide?: boolean,
    show: boolean,
    onRequestClose: () => void
}


type InternalModalProps = {
    children: any,
    title?: string | JSX.Element,
    type : "right" | "center" | "left",
    wide?: boolean,
    show: boolean,
    onRequestClose: () => void
}

type SmallModalProps = {
    children: any,
    text?: string,
    show: boolean,
    onRequestClose: () => void
}

type GlobalErrorModalProps = {
    code: string,
    message: string,
    show: boolean,
    onRequestClose: () => void
}
 
const Modal: FunctionComponent<InternalModalProps> = (props) => {

    let {children, title, type, wide = false, show, onRequestClose} = props; 

    const modalBackground = "modal-dialog";
    const hideModal = (event: React.MouseEvent<HTMLDivElement>)=>{
        event.target instanceof Element 
        && event.target.classList.contains(modalBackground)
        && onRequestClose()
    }

    const modalControlClasses = `modal-layout ${type == 'center' ? 'main-modal' : ''} ${wide && 'double-width'} ${show ? 'show' : ''}`

    return ( 
        <div className={modalControlClasses}>
            <div className={modalBackground} onClick={hideModal}>
                <div className="modal-content">
                    <div className="modal-title">
                        <h2>{title}</h2>
                        {type == 'center' && <IconButton tooltipText="Close" type="cross" onClick={onRequestClose} />}
                    </div>
                    <div className="modal-body">
                        <div className="modal-children">
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </div>
     );
}



export const SmallModal:FunctionComponent<SmallModalProps> = (props) =>{
    let {children, text, show, onRequestClose} = props; 

    const modalBackground = "modal-dialog";
    const hideModal = (event: React.MouseEvent<HTMLDivElement>)=>{
        event.target instanceof Element 
        && event.target.classList.contains(modalBackground)
        && onRequestClose()
    }

    const modalControlClasses = `modal-layout small-modal ${show ? 'show' : ''}`;
    return (
        <div className={modalControlClasses}>
            <div className={modalBackground} onClick={hideModal}>
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="modal-children">
                            {!text ? <h2>Are You sure?</h2> : <h2>{text}</h2>}
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export const GlobalErrorModal:FunctionComponent = () =>{

    let {code, message, isShowModal, hideModal} = useErrorHandlingStore();

    const modalBackground = "modal-dialog";
    const hideModalHandler = (event: React.MouseEvent<HTMLDivElement>)=>{
        event.target instanceof Element 
        && event.target.classList.contains(modalBackground)
        && hideModal()
    }

    const modalControlClasses = `modal-layout small-modal ${isShowModal ? 'show' : ''}`;
    return (
        <div className={modalControlClasses}>
            <div className={modalBackground} onClick={hideModalHandler}>
                <div className="modal-content error-handling">
                    <div className="modal-body">
                        <div className="modal-children">
                            <h2>Error</h2>
                            <p>{message}</p>
                            <div className="pt-20">
                                <Button color="gray" onClick={hideModal} label="Close" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


export const RightModal = (props: ModalProps) => Modal({type : "right", ...props });
export const CenterModal = (props: ModalProps) => Modal({type : "center", ...props });